import { render, staticRenderFns } from "./YMmpBanner.vue?vue&type=template&id=471f36a0&"
import script from "./YMmpBanner.vue?vue&type=script&lang=js&"
export * from "./YMmpBanner.vue?vue&type=script&lang=js&"
import style0 from "./YMmpBanner.vue?vue&type=style&index=0&id=471f36a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports